export default __webpack_public_path__ + "static/media/pic1.b01b1b81.jpg";